export const USERSNAP_API_KEY = '03355e78-2565-460c-8a3f-33e999c021dd';
export const USERSNAP_GLOBAL_API_KEY = '4641954d-99e3-46e6-8b43-4144efb85e4d';
